/**
 * Broker-activation wire types (Story ADMIN-W4).
 *
 * The public /auth/broker-activation endpoints: a broker employee invited via
 * the admin-wizard step ⑤ opens /einladung?token=…, previews the invitation
 * (firm + invited identity) and activates (sets the password → Keycloak user).
 *
 * RECONCILE NOTE (as-built ADMIN-W2): broker_invitation carries `role_id`
 * (FK → the COPIED tenant role of the dynamic-RBAC `role` table), NOT a
 * `membership_role` value. `role` here is therefore the resolved tenant role
 * NAME (e.g. 'admin' | 'basic' | a custom copied role) — display-only on the
 * client; the server derives every grant itself (rule #2).
 * `invitedByName` stays in the wire shape per the story AC but is always null
 * for now: the as-built W2 table has no invited_by column.
 */

/** Response of POST /auth/broker-activation/preview (display-only context). */
export interface BrokerActivationPreviewResponse {
  /** The inviting broker firm's name (tenant.name). */
  firmName: string;
  /** The invited address (the future Keycloak username). */
  email: string;
  /** The Anzeigename captured in wizard step ⑤. */
  displayName: string;
  /** Resolved tenant role NAME (see reconcile note above) — display only. */
  role: string;
  /** Always null in ADMIN-W4 (no invited_by column in the as-built W2 table). */
  invitedByName: string | null;
}

/** The single success status of POST /auth/broker-activation. */
export const BROKER_ACTIVATION_STATUS = 'activated' as const;

/** Response of POST /auth/broker-activation. */
export interface BrokerActivationResponse {
  status: typeof BROKER_ACTIVATION_STATUS;
}

/** Password policy bounds enforced at the DTO edge (server-side source of truth). */
export const BROKER_PASSWORD_MIN_LENGTH = 10;
export const BROKER_PASSWORD_MAX_LENGTH = 128;
